//#region src/order_refund_state.ts
var OrderRefundState = /* @__PURE__ */ function(OrderRefundState) {
	OrderRefundState[OrderRefundState["None"] = 0] = "None";
	OrderRefundState[OrderRefundState["RefundRequested"] = 1] = "RefundRequested";
	OrderRefundState[OrderRefundState["Refunded"] = 2] = "Refunded";
	return OrderRefundState;
}(OrderRefundState || {});
//#endregion
export { OrderRefundState };

//# sourceMappingURL=order_refund_state.js.map